import http from "../http";
import Service from "../../Service";

/**
 * @type PreOrderService
 */
export default class PreOrderService extends Service {

    update_delivery_date(id, store_id, seller_id, delivery_date) {
        return http.put(`/v2/clients/requests/${id}/stores/${store_id}/sellers/${seller_id}/delivery-date`, {
            delivery_date,
        }, {
            headers: this.getHeaders(),
        });
    }

    download_pdf(id, params) {
		return http.get(`/v2/clients/requests/${id}/pre-orders/pdf`, {
            params,
            headers: this.getHeaders(),
            responseType: 'arraybuffer'
        });
	}

    load(id, params) {
		return http.get(`/v2/clients/requests/${id}/pre-orders`, {
            headers: this.getHeaders(),
            params
        });
	}
}
